/* eslint-disable import/prefer-default-export */

/**
 * Get Video ID from URL
 *
 * @param url
 * @return {*}
 */
export const getVideoId = url => {
    if (!url) return null;

    // YouTube
    if (url.includes('youtube.com/watch?v=')) {
        return {type: 'youtube', id: url.split('?v=')[1]};
    }
    if (url.includes('youtube.com/embed/')) {
        return {type: 'youtube', id: url.split('embed/')[1]};
    }
    else if (url.includes('youtu.be/')) {
        return {type: 'youtube', id: url.split('youtu.be/')[1]};
    }

    // Vimeo
    const vimeoRegex = /https?:\/\/(www\.)?vimeo.com\/(.*\/)?(.*)/;
    const vimeoUrl = url.match(vimeoRegex);
    if (vimeoUrl && vimeoUrl[vimeoUrl.length-1] && !isNaN(vimeoUrl[vimeoUrl.length-1])) {
        return {type: 'vimeo', id: vimeoUrl[vimeoUrl.length-1]};
    }

    // Try to parse private link
    const vimeoRegexPrivate = /https?:\/\/(www\.)?vimeo.com\/(\d+)\//;
    const vimeoUrlPrivate = url.match(vimeoRegexPrivate);
    if (vimeoUrlPrivate && vimeoUrlPrivate[vimeoUrlPrivate.length-1] && !isNaN(vimeoUrlPrivate[vimeoUrlPrivate.length-1])) {
        return {type: 'vimeo', id: vimeoUrlPrivate[vimeoUrlPrivate.length-1]};
    }

    return null;
};



// WEBPACK FOOTER //
// ./frontend/helpers/video.js